import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatHeading } from '@blocks-react/components/Heading';
export const PreferenceLink = ({ text, link, linkText, className = 'mt-2 mb-4' }) => {
    return (_jsx("div", { className: className, children: _jsxs(CatHeading, { variant: "footnote", "data-testid": "notification-preferences-text-link", children: [' ', text, " ", _jsx("a", { href: link, children: linkText })] }) }));
};
